export const RETAINED_AUDIO_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;
export const RETAINED_AUDIO_MAX_BYTES = 100 * 1024 * 1024;
export const RETAINED_AUDIO_MAX_RECORDINGS = 12;

export function retainedAudioIsEligible(value, now = Date.now()) {
  return Boolean(value && value.version === 1 && typeof value.id === "string" &&
    /^[a-f0-9]{64}$/.test(value.id) && typeof value.ownerScope === "string" && value.ownerScope &&
    (value.kind === "brief" || value.kind === "news") && typeof value.label === "string" && value.label.trim() &&
    typeof value.detail === "string" && typeof value.language === "string" && value.language.length > 0 &&
    Number.isSafeInteger(value.savedAtEpochMs) && value.savedAtEpochMs > 0 && value.savedAtEpochMs <= now &&
    value.expiresAtEpochMs === value.savedAtEpochMs + RETAINED_AUDIO_MAX_AGE_MS && value.expiresAtEpochMs > now &&
    Number.isSafeInteger(value.byteLength) && value.byteLength > 0 && value.byteLength <= RETAINED_AUDIO_MAX_BYTES &&
    Number.isFinite(value.durationMs) && value.durationMs > 0 &&
    Array.isArray(value.sections) && value.sections.length > 0 && value.sections.length <= 40 &&
    new Set(value.sections.map((section) => section?.id)).size === value.sections.length &&
    value.sections.every((section, index) => section && typeof section.id === "string" && section.id.length > 0 && typeof section.title === "string" &&
      Number.isSafeInteger(section.startMs) && Number.isSafeInteger(section.endMs) &&
      section.startMs >= (index === 0 ? 0 : value.sections[index - 1].endMs) &&
      section.endMs > section.startMs));
}

/** Read/replay never renews a recording's accepted lifetime. */
export function boundedRetainedAudio(rows, ownerScope, now = Date.now()) {
  const candidates = rows.filter((row) => row.ownerScope === ownerScope && retainedAudioIsEligible(row, now))
    .sort((left, right) => right.savedAtEpochMs - left.savedAtEpochMs || left.id.localeCompare(right.id));
  let bytes = 0;
  return candidates.filter((row, index) => {
    if (index >= RETAINED_AUDIO_MAX_RECORDINGS || bytes + row.byteLength > RETAINED_AUDIO_MAX_BYTES) return false;
    bytes += row.byteLength;
    return true;
  });
}
